import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Akun berhasil dibuat!");
      navigate("/");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Pendaftaran gagal");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-[calc(100vh-5rem)] lumina-bg-soft flex items-center justify-center py-16" data-testid="register-page">
      <div className="lumina-card w-full max-w-md p-10">
        <div className="lumina-label mb-2">Daftar</div>
        <h1 className="font-serif text-4xl text-[#1A1728] mb-8">Mulai perjalananmu.</h1>
        <form onSubmit={submit} className="space-y-4">
          <input required placeholder="Nama lengkap" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="register-name" />
          <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="register-email" />
          <input required type="password" minLength={6} placeholder="Password (min. 6 karakter)" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="register-password" />
          <button disabled={loading} className="lumina-btn-primary w-full" data-testid="register-submit">{loading ? "Memproses…" : "Daftar"}</button>
        </form>
        <p className="text-sm text-[#5C5870] mt-6 text-center">Sudah punya akun? <Link to="/login" className="text-[#6B4BA3] font-medium">Masuk</Link></p>
      </div>
    </div>
  );
}
